import { LegalPage, LegalSection } from "@/components/layout/LegalPage";
import { useCompanySettings } from "@/context/SettingsContext";

export default function TermsPage() {
  const { settings } = useCompanySettings();
  const co = settings.company_name;
  return (
    <LegalPage title="Terms & Conditions" subtitle="Last updated: July 2026" testId="terms-page">
      <LegalSection title="1. Acceptance of Terms">
        <p>
          By accessing or using the {co} website, portals or services (collectively, the “Platform”), you agree to be
          bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not use the Platform.
        </p>
      </LegalSection>
      <LegalSection title="2. Platform Usage">
        <p>
          The Platform enables job seekers (“Members”) to discover verified job opportunities, apply to jobs, build resumes
          and track their applications. You agree to use the Platform only for lawful purposes and to provide accurate,
          current and complete information, including your legal name and a mobile number that belongs to you.
        </p>
        <p>
          {co} may modify, suspend or discontinue any part of the Platform at any time. We may also update job listings,
          remove listings that are filled or expired, and moderate content at our discretion.
        </p>
      </LegalSection>
      <LegalSection title="3. 100% Free for Job Seekers">
        <p>
          All candidate-facing services on the Platform — including job applications, application tracking and the Resume
          Builder — are provided completely free of charge. {co} never charges job seekers any registration fee, placement
          charge or service fee. If any person demands payment from you in the name of {co}, do not pay and report it
          immediately to {settings.support_email || "our support team"}.
        </p>
      </LegalSection>
      <LegalSection title="4. OTP-Based Authentication">
        <p>
          The Platform uses One-Time Passwords (OTPs) sent to your mobile number for login and identity verification.
          You are responsible for keeping your mobile device secure and for all activity that occurs through your verified
          mobile number. Never share your OTP with anyone — {co} staff will never ask you for your OTP.
        </p>
      </LegalSection>
      <LegalSection title="5. Resume Builder Usage">
        <p>
          The Resume Builder allows you to create, edit, preview and download resumes. You retain full ownership of the
          content you enter. You grant {co} a limited licence to store and process this content solely to provide the
          service, including sharing your resume and profile details with recruiters processing your job applications.
          You must not enter false, misleading or unlawful information in your resume.
        </p>
      </LegalSection>
      <LegalSection title="6. User Responsibilities">
        <p>You agree not to:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>Impersonate another person or use a mobile number that is not yours;</li>
          <li>Submit false applications or misleading information;</li>
          <li>Attempt to gain unauthorised access to the Platform or other users' data;</li>
          <li>Use automated scripts to scrape, spam or overload the Platform;</li>
          <li>Upload or transmit malicious code or unlawful content.</li>
        </ul>
        <p>Violation of these terms may result in suspension or permanent deactivation of your account.</p>
      </LegalSection>
      <LegalSection title="7. Intellectual Property">
        <p>
          All content on the Platform — including the {co} name, logo, design, software, resume templates and text — is the
          property of {co} or its licensors and is protected by applicable intellectual property laws. You may not copy,
          modify, distribute or create derivative works from any part of the Platform without prior written consent,
          except for resumes you create for your own personal use.
        </p>
      </LegalSection>
      <LegalSection title="8. Third-Party Services">
        <p>
          The Platform may contain links to or integrations with third-party services (such as WhatsApp for support chat).
          Your use of such services is governed by their own terms and privacy policies. {co} is not responsible for
          third-party services.
        </p>
      </LegalSection>
      <LegalSection title="9. Disclaimer">
        <p>
          The Platform is provided on an “as is” and “as available” basis. While we verify opportunities with reasonable
          care, {co} does not guarantee employment, interview selection, salary levels or the conduct of any employer.
          Hiring decisions rest solely with the respective employers.
        </p>
      </LegalSection>
      <LegalSection title="10. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, {co} shall not be liable for any indirect, incidental, special or
          consequential damages, or for any loss of employment opportunity, data or goodwill, arising out of or in
          connection with your use of the Platform. Since candidate services are free, {co}'s aggregate liability for any
          claim shall be limited to INR 1,000.
        </p>
      </LegalSection>
      <LegalSection title="11. Governing Law">
        <p>
          These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the
          courts of Pune, Maharashtra.
        </p>
      </LegalSection>
      <LegalSection title="12. Contact">
        <p>
          For questions about these Terms & Conditions, contact us at {settings.support_email || "our support email"} or
          {" "}{settings.contact_number || "our contact number"}.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
